import { translate } from '@jsverse/transloco';
export enum SourceType {
    IMPORT = 'IMPORT',
    LOG = 'LOG',
    ENDPOINT = 'ENDPOINT',
    SCAN = 'SCAN',
    EXTERNAL = 'EXTERNAL',
    UTM = 'UTM',
    INTERNAL = 'INTERNAL',
}

export class SourceTypeHelper {
    static getSourceTypeLocale(sourceType: SourceType) {
        switch (sourceType) {
            case SourceType.IMPORT:
                return translate('CORE.SOURCE_TYPE.IMPORT');
            case SourceType.LOG:
                return translate('CORE.SOURCE_TYPE.LOG');
            case SourceType.ENDPOINT:
                return translate('CORE.SOURCE_TYPE.ENDPOINT');
            case SourceType.SCAN:
                return translate('CORE.SOURCE_TYPE.SCAN');
            case SourceType.EXTERNAL:
                return translate('CORE.SOURCE_TYPE.EXTERNAL');
            case SourceType.UTM:
                return translate('CORE.SOURCE_TYPE.UTM');
            case SourceType.INTERNAL:
                return translate('CORE.SOURCE_TYPE.INTERNAL');
            default:
                return sourceType;
        }
    }
}
